var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-tabs',[_c('b-tab',{attrs:{"id":"application","title":"Application"}},[_c('student-application-documents')],1),_c('b-tab',{attrs:{"id":"visa","title":"Visa"}},[_c('student-visa-documents')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }